export default "__VITE_ASSET__uNmERzIL__"